import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BotonToggleModule } from "../../../components/boton/boton-toggle.module";
import { MaterialModule } from "../../../components/material/material.module";
import { NgxPermissionsModule } from "ngx-permissions";
import { GrupoUsuariosRoutingModule } from "./grupo-usuarios-routing.module";
import { GrupoUsuariosComponent } from "./grupo-usuarios.component";
import { GrupoUsuarioModule } from "../../../forms/grupo-usuarios/grupo-usuario.module";


@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        BotonToggleModule,
        MaterialModule,
        GrupoUsuariosRoutingModule,
        GrupoUsuarioModule
    ],
    declarations: [
        GrupoUsuariosComponent      
    ],
    providers: [
    ],
    entryComponents: [
    ] 
})
export class GrupoUsuariosModule { }